import React, { useState, useRef } from 'react'
import { Table, Button, Select } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import { useAsync } from 'react-use'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'

const { Option } = Select

const List = () => {
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const [version, setVersion] = useState()
  const { t } = useLocalization()

  const state = useAsync(async () => {
    const versions = await client
      .get('/checklist/versions', {
        params: { type: 'development' },
      })
      .then((res) => res.data)
    const result = versions.map((item) => item.version).reverse()
    if (result.length > 0) {
      setVersion(result[0])
    }
    return result
  }, [])

  const handleReload = () => {
    fetchRef.current.reload()
  }
  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const changeVersion = (v) => {
    setVersion(v)
  }

  const fetch = async ({ page, pageSize, version }) => {
    const result = await client
      .get('/checklist', {
        params: {
          where: JSON.stringify({
            type: 'development',
            version,
          }),
          skip: (page - 1) * pageSize,
          limit: pageSize,
          order: { from: 'ASC' },
        },
      })
      .then((res) => res.data)
    return result
  }
  // Old width without ENG has '20%','10%','20%','15%','15%','10%','10%'
  const columns = [
    {
      title: t('development.listScreen.column.title'),
      dataIndex: 'title',
      key: 'title',
      width: '10%',
    },
    {
      title: t('development.listScreen.column.description'),
      dataIndex: 'description',
      key: 'description',
      width: '15%',
    },
    {
      title: t('development.listScreen.column.detail'),
      dataIndex: 'detail',
      key: 'detail',
      width: '15%',
    },
    {
      title: t('development.listScreen.column.titleEn'),
      dataIndex: 'titleEn',
      key: 'titleEn',
      width: '10%',
    },
    {
      title: t('development.listScreen.column.descriptionEn'),
      dataIndex: 'descriptionEn',
      key: 'descriptionEn',
      width: '15%',
    },
    {
      title: t('development.listScreen.column.detailEn'),
      dataIndex: 'detailEn',
      key: 'detailEn',
      width: '15%',
    },
    {
      title: t('development.listScreen.column.from'),
      dataIndex: 'from',
      key: 'from',
      width: '5%',
    },
    {
      title: t('development.listScreen.column.to'),
      dataIndex: 'to',
      key: 'to',
      width: '5%',
    },
    {
      title: t('development.listScreen.column.priority'),
      dataIndex: 'priority',
      key: 'priority',
      width: '5%',
    },
    {
      title: t('development.listScreen.column.alertMo'),
      dataIndex: 'alertMo',
      key: 'alertMo',
      width: '5%',
    },
  ]

  return (
    <Fetch fetch={fetch} params={{ page, pageSize, version }} ref={fetchRef}>
      {({ data, total }) => (
        <PageLayout
          title={t('development.listScreen.title')}
          createPath="/development/create"
          shownBack={false}
          extra={[
            <Button
              key="reload"
              icon={<ReloadOutlined />}
              onClick={handleReload}
            >
              {t('development.listScreen.reload')}
            </Button>,
            <span key="version">
              <Select
                value={version}
                style={{ width: 100 }}
                onSelect={changeVersion}
              >
                {(state.value || []).map((v) => (
                  <Option key={v} value={v}>
                    v. {v}
                  </Option>
                ))}
              </Select>
            </span>,
          ]}
        >
          <Table
            rowKey="id"
            onChange={handleChange}
            columns={columns}
            dataSource={data}
            pagination={{
              defaultCurrent: defaultPageSize,
              defaultPageSize: defaultPageSize,
              current: page,
              pageSize,
              total,
            }}
          />
        </PageLayout>
      )}
    </Fetch>
  )
}

export default List
